import React, { useContext } from 'react'
import { Form, Formik } from 'formik'
import Layout from '../components/Layout'
import { useMessage } from '../hooks/message'
import { usePutRequest } from '../hooks/request'
import { CHANGE_PASSWORD, USER_SETTINGS } from '../urls'
import UserForm from '../components/UserForm'
import UserChangePassword from '../components/UserChangePassword'
import SettingsTabs from '../components/SettingsTabs'
import Card from '../components/common/Card'
import { useUser } from '../hooks/user'
import useTrans from '../hooks/trans'
import Select from '../components/common/Select'
import { themes } from '../utils/themes'
import { ThemeContext } from '../contexts/ThemeContext'

export default function SettingsUser() {
    const updateUserSetting = usePutRequest({ url: USER_SETTINGS })
    const changePassword = usePutRequest({ url: CHANGE_PASSWORD })
    const { theme, setTheme } = useContext(ThemeContext)
    const [showMessage] = useMessage()
    const t = useTrans()
    const [user, setUser] = useUser()

    async function onSubmit(data) {
        const { response, error } = await updateUserSetting.request({ data })
        if (error) {
            showMessage(error.data, 'is-danger')
            return
        }

        localStorage.setItem('user', JSON.stringify(response))
        setUser(response)
        showMessage(t('informationChanged'), 'is-success')
    }

    async function updatePassword(data, actions) {
        if (data.newPassword !== data.confirmPassword) {
            showMessage(t('passwordChanged'), 'is-danger')
            return
        }

        const { error } = await changePassword.request({ data, newPassword: data.newPassword })
        if (error) {
            showMessage(t('oldPassword'), 'is-danger')
        } else {
            showMessage(t('newPassword'), 'is-success')
        }
        actions.resetForm()
    }

    return (
        <Layout className="has-background-light">
            <SettingsTabs />

            <div className="columns">
                <div className="column">
                    <Card>
                        <UserForm user={user} onSubmit={onSubmit} />
                    </Card>
                </div>&nbsp;

                <div className="column">
                    <Card>
                        <UserChangePassword onSubmit={updatePassword} />
                    </Card>
                </div>
            </div>

            <div className="columns">
                <div className="column is-6">
                    <Card>
                        <Formik initialValues={{ themes: theme || '' }}>
                            <Form>
                                <Select
                                    name="themes"
                                    label={t('themes')}
                                    onChange={(e) => {
                                        setTheme(e.target.value)
                                    }}
                                    optionValue="value"
                                    optionLabel="name"
                                    options={themes.map(({ value, name }) => ({ value, name: t(name) }))} />
                            </Form>
                        </Formik>
                    </Card>
                </div>
            </div>
        </Layout>
    )
}
